// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import type { OperationComponent, QueryProps } from "react-apollo";

export const userResultsQuery = gql`
  query($userId: ID) {
    allProjects {
      id
      name
      hasObjectiveAnswers
      tasks(filter: { results_some: { user: { id: $userId } } }) {
        id
        question
        answer
        responseTimesInSeconds
        results(filter: { user: { id: $userId } }, orderBy: secondsLimit_ASC) {
          id
          createdAt
          kind
          secondsElapsed
          secondsLimit
          confidence
        }
      }
    }
  }
`;

export type UserTask = {
  id: string,
  question: string,
  answer: boolean,
  responseTimesInSeconds: Array<number>,
  results: Array<{
    createdAt: Date,
    kind: "response" | "timeout",
    secondsElapsed: number,
    secondsLimit: number,
    confidence: number
  }>
};

export type UserProject = {
  id: string,
  name: string,
  hasObjectiveAnswers: boolean,
  tasks: Array<UserTask>
};

export type userResultsQueryResult = {
  userResultsData: {
    allProjects?: Array<UserProject>
  } & QueryProps
};

export const withUserResults: OperationComponent<
  userResultsQueryResult,
  { userId: string }
> = graphql(userResultsQuery, {
  options: ({ userId }) => ({
    variables: { userId }
  }),
  name: "userResultsData"
});



// WEBPACK FOOTER //
// ./src/data/user-results.js